import React from 'react';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import { Home } from './pages/Home';
import { Privacy } from './pages/Privacy';
import { Admin } from './pages/Admin';
import './App.css'
import logo from './images/logo.jpg'
import {Schedule} from "./pages/Schedule";

function App() {
  return (
      // BrowserRouter должен оборачивать всё приложение один раз
      <BrowserRouter>
        <div className="app-container">
          {/* Навигационное меню */}
          <nav>
            <div className="nav-content">
              <img className="nav-logo" src={logo} alt="Логотип"/>
              <Link to="/">Главная</Link>
            </div>
          </nav>

          {/* Здесь будут рендериться страницы в зависимости от URL */}
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/schedule" element={<Schedule />} />

              <Route path="*" element={<h2>Страница не найдена (404)</h2>} />
            </Routes>
          </main>
        </div>
      </BrowserRouter>
  );
}

export default App;